module.exports = __webpack_public_path__ + "img/alfa-romeo.95d28ee0.webp";